import apiFetch from '../../apiFetch'

export default function (grupoVerracoAnadidas, token) {
  return apiFetch({endPoint: `Bioseguridad/getGrupoVerraco`, method: 'POST', body: grupoVerracoAnadidas, token: token})
}
